export const FETCH_ITEM = 'NRC_EDITOR/FETCH_ITEM';
export const FETCH_ITEM_SUCCESS = 'NRC_EDITOR/FETCH_ITEM_SUCCESS';
export const FETCH_ITEM_ERROR = 'NRC_EDITOR/FETCH_ITEM_ERROR';
export const ADD_TO_CART = 'NRC_EDITOR/ADD_TO_CART';
export const ADD_TO_CART_SUCCESS = 'NRC_EDITOR/ADD_TO_CART_SUCCESS';
export const ADD_TO_CART_ERROR = 'NRC_EDITOR/ADD_TO_CART_ERROR';
export const ADD_FAVORITE = 'NRC_EDITOR/ADD_FAVORITE';
export const ADD_FAVORITE_SUCCESS = 'NRC_EDITOR/ADD_FAVORITE_SUCCESS';
export const ADD_FAVORITE_ERROR = 'NRC_EDITOR/ADD_FAVORITE_ERROR';
export const CHECK_FAVORITE = 'NRC_EDITOR/CHECK_FAVORITE';
export const CHECK_FAVORITE_SUCCESS = 'NRC_EDITOR/CHECK_FAVORITE_SUCCESS';
export const CHECK_FAVORITE_ERROR = 'NRC_EDITOR/CHECK_FAVORITE_ERROR';
export const SET_TEMPLATE_CODE = 'NRC_EDITOR/SET_TEMPLATE_CODE';
export const SET_QUANTITY = 'NRC_EDITOR/SET_QUANTITY';
export const SET_IMAGE = 'NRC_EDITOR/SET_IMAGE';
export const SET_PRODUCT = 'NRC_EDITOR/SET_PRODUCT';
export const SET_NOTES = 'NRC_EDITOR/SET_NOTES';
export const RESET_STATE = 'NRC_EDITOR/RESET_STATE';
export const SET_ACTION = 'NRC_EDITOR/SET_ACTION';